import React from 'react';
import { Result, Button, Typography } from 'antd';
import { BuildOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ConstructionPage = ({ title = "Módulo en Desarrollo" }) => {
    const navigate = useNavigate();

    return (
        <div className="fade-in" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '70vh'
        }}>
            <Result
                icon={<BuildOutlined style={{ color: '#DA291C', fontSize: '64px' }} />}
                title={<Title level={2}>{title}</Title>}
                subTitle={<Text type="secondary" style={{ fontSize: '18px' }}>Pagina de construcción</Text>}
                extra={
                    <Button type="primary" size="large" onClick={() => navigate('/')}>
                        Volver al Dashboard
                    </Button>
                }
            />
        </div>
    );
};

export default ConstructionPage;
